import { Button, Container, Grid } from "@mui/material";
import React from "react";
import { SectionHeading, SectionWrapper } from "../../Styles/style";
import { useTheme } from "@emotion/react";
import { useState } from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import footerman from "../../../assets/images/footerman.png";
import arrow from "../../../assets/images/0protocol.png";

import Videostars from "../../../assets/images/mixed.mp4";

const tabContainerStyles = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  border-bottom: 1px solid #ccc;
`;

const activeTabStyles = css`
  border-bottom: 3px solid #000;
  background-color: red;
`;

const MixerButton = styled(Button)`
  padding: 20px;
  background-color: rgb(23, 77, 255);
  color: #fff;
`;
const BuyNow = styled.a`
  text-decoration: none;
  background-color: #174dff;
  color: #fff;
  padding: 12px 20px;
  border-radius: 50px;
  display: flex;
  max-width: 160px;
  align-items: center;
  margin-top: 30px;
`;
const ManImg = styled.img`
  width: 100%;
  height: auto;
  max-width: 300px;
`;
const GridWrapper = styled(Grid)`
  display: flex;
  align-items: center;
`;
const GridWrapperss = styled(Grid)`
  display: flex;
  align-items: center;
  // @media (max-width: 425px) {
  //   display:block;
  //   text-align-last: center !important;
  // }
`;
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`;
const GridVideo = styled(Grid)`
  mix-blend-mode: lighten !important;
`;
const BottomGrid = styled.div`
  box-sizing: border-box;
  margin: 20px 0px;
  flex-direction: row;
  flex-basis: 100%;
  -webkit-box-flex: 0;
  flex-grow: 0;
  max-width: 100%;
  text-align: left;
  display: grid;
  grid-template-columns: auto auto auto auto;
  gap: 22px 10px;
  place-items: left;

  @media (max-width: 425px) {
    grid-template-columns: auto auto;
    place-items: center;
    text-align: center;
  }
`;
const ChildGrid = styled.div`
  justify-self: center;
  // text-align-last: left;
  // @media (max-width: 768px) {
  // text-align-last: center !important;
  // }
`;
const P = styled.p`
  font-weight: ${(props) => (props.fw ? props.fw : "")};
  font-family: "P-L";
  font-size: ${(props) => (props.fs ? props.fs : "18px")};
  color: ${(props) => (props.color ? props.color : props.theme.textPrimary)};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin: ${(props) => (props.m ? props.m : "20px 0")};
  padding: ${(props) => (props.p ? props.p : "")};
  display: ${(props) => (props.display ? props.display : "")};
  justify-content: ${(props) => (props.jc ? props.jc : "")};
  // border-bottom: 1px solid #fff;
  // padding-bottom:70px;
  @media (max-width: 600px) {
    font-size: ${(props) => (props.fs600px ? props.fs600px : "")};
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
`;
const P1 = styled.p`
  margin-bottom: 0 !important;
  font-weight: ${(props) => (props.fw ? props.fw : "900")};
  font-family: "P-L";
  font-size: ${(props) => (props.fs ? props.fs : "20px")};
  color: ${(props) => (props.color ? props.color : props.theme.textPrimary)};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin: ${(props) => (props.m ? props.m : "20px 0")};
  padding: ${(props) => (props.p ? props.p : "")};
  display: ${(props) => (props.display ? props.display : "")};
  justify-content: ${(props) => (props.jc ? props.jc : "")};
  @media (max-width: 600px) {
    font-size: ${(props) => (props.fs600px ? props.fs600px : "")};
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
`;
const P2 = styled.p`
  margin: 0 !important;
  font-weight: ${(props) => (props.fw ? props.fw : "")};
  font-family: "P-L";
  font-size: ${(props) => (props.fs ? props.fs : "14px")};
  color: ${(props) => (props.color ? props.color : props.theme.textPrimary)};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin: ${(props) => (props.m ? props.m : "20px 0")};
  padding: ${(props) => (props.p ? props.p : "")};
  display: ${(props) => (props.display ? props.display : "")};
  justify-content: ${(props) => (props.jc ? props.jc : "")};
  @media (max-width: 600px) {
    font-size: ${(props) => (props.fs600px ? props.fs600px : "")};
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
`;
const Para = styled.p`
  font-weight: ${(props) => (props.fw ? props.fw : "900")};
  font-family: "P-L";
  font-size: ${(props) => (props.fs ? props.fs : "25px")};
  color: ${(props) => (props.color ? props.color : props.theme.textPrimary)};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin: ${(props) => (props.m ? props.m : "20px 0")};
  padding: ${(props) => (props.p ? props.p : "")};
  display: ${(props) => (props.display ? props.display : "")};
  justify-content: ${(props) => (props.jc ? props.jc : "")};
  border-top: 1px solid #fff;
  padding-top: 30px;
  @media (max-width: 600px) {
    font-size: ${(props) => (props.fs600px ? props.fs600px : "")};
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
`;

const TabList = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
`;

const TabButton = styled.div`
  padding: 10px 20px;
  margin-right: 10px;
  border: 1px solid gray;
  cursor: pointer;

  ${(props) =>
    props.active &&
    `
    background-color: blue;
    color: white;
  `}
`;
const SubHeading = styled.h2`
  color: ${(props) => (props.color ? props.color : props.theme.textPrimary)};
  font-size: ${(props) =>
    props.fs
      ? props.fs
      : "calc(22px + (26 - 22) * ((100vw - 146px) / (1600 - 250)))"};
  font-family: "P-R";
  width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  padding: ${(props) => (props.p ? props.p : "10px 0")};
  text-align: ${(props) => (props.align ? props.align : "")};
  font-weight: 900;
  margin: ${(props) => (props.m ? props.m : "")};
  @media screen and (max-width: 972px) {
    font-size: ${(props) =>
      props.fs
        ? props.fs
        : "calc(22px + (26 - 20) * ((100vw - 16px) / (1600 - 250)))"};
  }
  @media screen and (max-width: 419px) {
    font-size: ${(props) =>
      props.fs
        ? props.fs
        : "calc(22px + (26 - 10) * ((100vw - 26px) / (1600 - 250)))"};
  }
`;
const TabNav = styled.div`
  // border: 1px solid rgb(43, 93, 255);
  padding: 15px 0;
  background-color: #fff;
  color: rgb(43, 93, 255);
  border-radius: 50px;
  margin-bottom: 10px;
  font-weight: 900;
  width: 100%;
  &:hover {
    color: #fff;
    background-color: rgb(43, 93, 255);
  }
  &:active {
    color: #fff;
    background-color: rgb(43, 93, 255);
  }
`;
const MobileTabNav = styled.div`
  padding: 18px 9px;
  // background-color: #fff;
  color: #fff;
  /* border-radius: 50px; */
  margin-bottom: 10px;
  font-weight: 900;
  border: 2px solid rgb(43, 93, 255);
  display: flex;
  border-right: none;
  align-items: center;
  font-size: 12px;
  &:hover {
    color: #fff;
    background-color: rgb(43, 93, 255);
  }
  &:active {
    color: #fff;
    background-color: rgb(43, 93, 255);
  }
  &:first-child {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    border-right: none;
  }
  &:last-child {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    border-right: 1px solid rgb(43, 93, 255);
  }
`;

const Mobile = styled.div`
  @media screen and (min-width: 770px) {
    display: none;
  }
`;
const Desktop = styled.div`
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const Tab = ({ label, active, onClick }) => {
  return (
    <TabButton active={active} onClick={onClick}>
      {label}
    </TabButton>
  );
};

const Tabs = ({ children }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div>
      <TabList>
        {React.Children.map(children, (child, index) => (
          <Tab
            key={index}
            label={child.props.label}
            active={activeTab === index}
            onClick={() => handleClick(index)}
          />
        ))}
      </TabList>
      <div>{React.Children.toArray(children)[activeTab].props.children}</div>
    </div>
  );
};

const Section8_Team = () => {
  const theme = useTheme();

  const [activeTab, setActiveTab] = useState(0);
  const tabs = [
    {
      id:'Mix',
      label: "Mixer",
      image: "https://testingdap.zkinu.finance/Img/Mixer.png",
      heading: "Mixer",
      content:
        "Øero's mixers allows users to keep their transactions private with ease. Simply choose a set amount and have it transferred to a wallet of your liking.",
    },
    {
      id:'ss',
      label: "Visa Card",
      image: "https://testingdap.zkinu.finance/Img/card.png",
      heading: "Visa Card",
      content:
        "Øero's virtual Visa card allows users to make seamless online transactions from anywhere while not compromising on their privacy. Creating your own Visa card can be done in a few easy clicks!",
    },
    {
      id:'rrr',
      label: "Anon Bridge",
      image: "https://testingdap.zkinu.finance/Img/anonbridge1.png",
      heading: "Anon Bridge",
      content:
        "The Anon Bridge allows users to anonymously send their tokens across networks.Users can move over to new blockchains with everyone else being none the wiser.",
    },
    {
      id:'',
      label: "Staking",
      image: "https://testingdap.zkinu.finance/Img/staking.png",
      heading: "Staking",
      content:
        "Øero's staking program has users hold their tokens for a certain period of time to earn rewards and support the network's operations.",
    },
    {
      label: "DAO",
      image: "https://testingdap.zkinu.finance/Img/Dao.png",
      heading: "DAO",
      content:
        "The DAO, or decentralized autonomous organization, empowers the Øero community to democratize decision-making processes by allowing holders to vote and reach a consensus on future endeavors. This innovative approach ensures that Øero's future initiatives align with the desires and interests of its community, fostering a more inclusive and collaborative ecosystem.",
    },
  ];
  return (
    <SectionWrapper
      p799="8rem 0 8rem 0"
      p599="8rem 0px 8rem 0"
      p="4rem 0 4rem 0"
      id="ecosystem"
    >
      <Container
        maxWidth="xl"
        data-aos="fade-zoom-in"
        data-aos-easing="ease-in"
        data-aos-delay="500"
        data-aos-duration="500"
        data-aos-offset="0"
      >
        <GridWrapper container>
          <Grid item xs={12} md={6} style={{ textAlignLast: "left" }}>
            <Mobile>
              <SectionHeading
                p="20px 0"
                m="0"
                align="left"
                color={theme.textSecondary}
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="500"
                data-aos-offset="0"
              >
                ØERO <br /> ECOSYSTEM
              </SectionHeading>
              <div style={{ display: "flex", justifyContent: "center" }} id={"#" + tabs[activeTab].id}>
                {tabs.map((tab, index) => (
                  <MobileTabNav
                    key={index}
                    css={[index === activeTab && activeTabStyles]}
                    onClick={() => setActiveTab(index)}
                  >
                    {tab.label}
                  </MobileTabNav>
                ))}
              </div>
            </Mobile>
            <ManImg src={tabs[activeTab].image} />
            <br />
            <SubHeading>{tabs[activeTab].heading}</SubHeading>

            <P
              p="0"
              m="0"
              color={theme.textSecondary}
              data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="500"
              data-aos-duration="500"
              data-aos-offset="0"
              style={{ margin: "0" }}
            >
              {tabs[activeTab].content}
              <br />
            </P>
          </Grid>
          <GridVideo
            xs={12}
            md={6}
            data-aos="flip-down"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="700"
            data-aos-offset="0"
          >
            <Desktop>
              <SectionHeading
                p="20px 0"
                m="0"
                align="left"
                color={theme.textSecondary}
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="500"
                data-aos-offset="0"
              >
                ØERO <br /> ECOSYSTEM
              </SectionHeading>

              <div>
                {tabs.map((tab, index) => (
                  <TabNav
                    key={index}
                    css={[index === activeTab && activeTabStyles]}
                    onClick={() => setActiveTab(index)}
                  >
                    {tab.label}
                  </TabNav>
                ))}
              </div>
            </Desktop>
          </GridVideo>
        </GridWrapper>
      </Container>
    </SectionWrapper>
  );
};

export default Section8_Team;
